module.exports = __webpack_public_path__ + "static/bg04-b70dac9772d5f9081440d8b68a7e19d9.jpg";